<template>
    <div>
        This is the promotions list page 
        
    </div>
</template>


<script>
export default {
    name: "Promotions"
}
</script>